module.exports = __webpack_public_path__ + "media/customizations/westphalia/logo-new-32d7eb04dc6d1133eff5495fdc5cbe9f.png";